// extracted by mini-css-extract-plugin
module.exports = {"row":"team-module--row--J4TQS","person":"team-module--person--BkaUl","header":"team-module--header--2jrt7","image":"team-module--image--37wRH","title":"team-module--title--1K5NW"};